export default "__VITE_ASSET__C6FTeGyk__"